import gql from 'graphql-tag'

const FLOOR_PLAN_FIELDS_FRAGMENT = gql`
  fragment FloorPlanFields on FloorPlan {
    id
    title
    propertyType
    bedrooms
    baths
    halfBaths
    baseSqft
    exteriorSqft
    den
    basement
    virtualTourUrl
    collection {
      id
      name
    }
    images {
      id
      sequence
      url
    }
    documents {
      id
      title
      sequence
      url
      file {
        mimeType
      }
    }
  }
`

export default ($edgewise) => ({
  get: (...args) => get($edgewise, ...args),
  list: (...args) => list($edgewise, ...args)
})

async function get($edgewise, floorPlanId) {
  try {
    const { floorPlan } = await $edgewise.graphqlClient.request(
      gql`
        ${FLOOR_PLAN_FIELDS_FRAGMENT}
        query jssdk_get_floor_plan($floorPlanId: ID!) {
          floorPlan(id: $floorPlanId) {
            ...FloorPlanFields
          }
        }
      `,
      { floorPlanId }
    )

    return floorPlan
  } catch (err) {
    console.error(err)
    throw err
  }
}

async function list($edgewise, input) {
  try {
    const { project } = await $edgewise.graphqlClient.request(
      gql`
        ${FLOOR_PLAN_FIELDS_FRAGMENT}
        query jssdk_list_floor_plans($projectId: ID!) {
          project(id: $projectId) {
            id
            floorPlans {
              ...FloorPlanFields
            }
          }
        }
      `,
      input
    )

    return project.floorPlans
  } catch (err) {
    console.error(err)
    throw err
  }
}
